import { render, staticRenderFns } from "./news.vue?vue&type=template&id=b10be2d4&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&lang=less&"
import style1 from "./news.vue?vue&type=style&index=1&id=b10be2d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10be2d4",
  null
  
)

export default component.exports